import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';
import { ValidateRfServiceInterface } from '../interfaces/services/validate-rf.service.interface';
import { ValidateRfInput, ValidateRfOutput } from '../dtos/representative.dto';

const RF_TIMEOUT_MS = 10000;

@Injectable()
export class ValidateRfService implements ValidateRfServiceInterface {
  private readonly _representativeRepository = inject(
    Types.RepresentativeRepository
  );

  async handle(input: ValidateRfInput): Promise<ValidateRfOutput> {
    const timeout = new Promise<ValidateRfOutput>((resolve) =>
      setTimeout(
        () => resolve({ valid: false, motivo: 'timeout' }),
        RF_TIMEOUT_MS
      )
    );

    const request = this._representativeRepository.validateRf(input);

    return Promise.race([request, timeout]);
  }
}
